import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useQuery } from '@tanstack/react-query';

import { userService } from '../../application/UserService';
import { useShowSnackbarMessage } from '../snackbarMessage/useShowSnackbarMessage';

type UseResendUserValidationPhoneResponse = ServiceResponse<() => void, void>;

// Hooks act as 'Adapter' layer.
const useResendUserValidationPhone = (): UseResendUserValidationPhoneResponse => {
  const { showSnackbarMessage } = useShowSnackbarMessage();

  const { isError, refetch, isSuccess, isLoading } = useQuery(
    [`planner_resend_validation_phone`],
    () => userService.resendValidationPhone(),
    {
      enabled: false,
      retry: false,
      refetchOnWindowFocus: false,
      onSuccess(data) {
        showSnackbarMessage({
          type: `success`,
          messageIntlId: `user.otp_sent`,
        });
      },
      onError: (err: any) => {
        console.info(`Resend Validation Phone User Error: `, err?.response);

        showSnackbarMessage({
          messageIntlId: `infoerror.${err?.response?.data?.messageId ?? `network_error`}`,
        });
      },
    }
  );

  return {
    success: isSuccess,
    error: isError,
    isLoading,
    run: () => refetch(),
  };
};

export default useResendUserValidationPhone;
